import Vue from "vue"
import Vuex from "vuex"
import axios from 'axios'

Vue.use(Vuex)

const state = {
  token: localStorage.getItem('token') || '',
  jobs: [],
  user: {},
  status: '',

}

const getters = {
  curlocation: (state) => {
    if(state.user) {
      if (state.user.defaultIDC) {
        return state.user.defaultIDC
      }
      else if (state.user.availableIDC){
        return state.user.availableIDC[0]
      }
    }
    else {
      return ''
    }
  },
  idcs: (state) => {
    if(state.user) {
      return state.user.availableIDC
    }
    return []
  },
  newjobs: (state) => {
    return state.jobs.filter(job => job.status === 1||job.status === 2|| job.status === 3 )
  },
  joblayer1: (state) => {
    return state.jobs.filter(job => job.status === 4 || job.status === 8)
  },
  joblayer2: (state) => {
    return state.jobs.filter(job => job.status === 5 || job.status === 7)
  },
  joblayer3: (state) => {
    return state.jobs.filter(job => job.status === 6)
  },
  isAuthenticated: state => !!state.token,
  is_admin: state => { 
    if(state.user) {
      if(state.user.permission >=7) {
        return true
      }
      return false
    }
   
  else {
    return false
  }
},
  permit_l1: state =>{
    if(state.user) {
      if(state.user.permission === 1|| state.user.permission === 3) {
        return true
      }
      return false
    }
    return false
  },
  permit_l2: state =>{
    if(state.user) {
      if(state.user.permission === 2|| state.user.permission === 3) {
        return true
      }
      return false
    }
    return false
  },
  permit_l3: state =>{
    if(state.user) {
      if(state.user.permission > 4) {
        return true
      }
      return false
    }
    return false
  }
}

const mutations = {

  GET_NEWJOBS(state, jobs)
  {
    Vue.set(state, 'jobs', jobs)
  },
  UPDATEJOB(state,job){
    for (var i=0;i< state.jobs.length;i++)
    {
      if(state.jobs[i]._id === job._id) {
        state.jobs[i] = job
      }
    }
  },
  auth_request(state){
    Vue.set(state,'status','loading')
  },
  set_user(state,user){
    state.user = user
  },
  auth_success(state, token){
    state.status= 'success'
    state.token= token
    
  },
  auth_error(state){
    state.status = 'Login error'
  },
  logout(state){
    state.status = ''
    state.token = ''
  },

}

const actions = {

  async getcurrentjobs({commit}, jobs) {    
    commit('GET_NEWJOBS', jobs)
  },
  updatejob(context,job)
  {
    context.commit('UPDATEJOB',job)
  },
  update_request(context, status)
  {
    context.commit('auth_request', status)
  },
  update_success(context,token)
  {
    context.commit('auth_success',token)
  },
  update_error(context)
  {
    context.commit('auth_error')
  },
  update_user(context, user){
    context.commit('set_user',user)
  },
  logout({commit}){
    return new Promise((resolve) => {
    commit('logout')
    localStorage.removeItem('token')
    delete axios.defaults.headers.common['Authorization']
    resolve()
  })
}
}
const store = new Vuex.Store({state, getters, mutations, actions})
export default store

